import { render, staticRenderFns } from "./ControlHorario.vue?vue&type=template&id=dadab41a&"
import script from "./ControlHorario.vue?vue&type=script&lang=js&"
export * from "./ControlHorario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports